const { getElement } = window.BAO.Utils

class WishlistVariantSelector extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(
      document.body,
      'wishlist-variant-info:triggered',
      event => this.populateVariants(event),
    )

    this.listeners.add(this, 'click', this.handleVariantSelectors)

    this.listeners.add(
      document.body,
      'global-wishlist-variant-selector:closed',
      this.revertModal.bind(this),
    )
  }

  populateVariants (event) {
    const detaisElement = document.querySelector(`.${event.detail.id}`)
    this.variantInfoContainer.innerHTML = detaisElement.innerHTML
  }

  handleVariantSelectors (event) {
    const variantTrigger = event.target.closest('button[data-variant-trigger]')

    if (!variantTrigger) return

    this.revertVariants()
    variantTrigger.classList.add('is-Active')

    this.wishlistTrigger.dataset.productId = variantTrigger.dataset.productId
    this.wishlistTrigger.dataset.variantId = variantTrigger.dataset.variantId
    this.wishlistTrigger.classList.add('is-Active')
  }

  revertModal () {
    this.variantInfoContainer.innerHTML = ''
    this.revertWishlistTrigger()
  }

  onVariantSelect (event) {
    this.revertVariants()
    event.target.classList.add('is-Active')

    this.wishlistTrigger.dataset.productId = event.target.dataset.productId
    this.wishlistTrigger.dataset.variantId = event.target.dataset.variantId
    this.wishlistTrigger.classList.add('is-Active')
  }

  revertVariants () {
    const variantTriggers = this.querySelectorAll(
      'button[data-variant-trigger]',
    )
    variantTriggers.forEach(el => el.classList.remove('is-Active'))
  }

  revertWishlistTrigger () {
    this.wishlistTrigger.dataset.productId = ''
    this.wishlistTrigger.dataset.variantId = ''
    this.wishlistTrigger.classList.remove('is-Active')
  }

  get wishlistTrigger () {
    return getElement('button[data-wishlist-trigger]', {
      context: this,
    })
  }

  get variantInfoContainer () {
    return getElement('.wishlist-variant-container', {
      context: this,
    })
  }
}

if (!window.customElements.get('wishlist-variant-selector')) {
  window.customElements.define(
    'wishlist-variant-selector',
    WishlistVariantSelector,
  )
}
